import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Opt-out for the ``errorInterceptor``'s global toast.
 *
 * Feature components that surface HTTP errors inline (dialog banners,
 * form field errors, page-level error strips) should set this to true on
 * the specific requests they handle themselves — otherwise the user sees
 * the same error twice: once in the component's inline surface, and once
 * as a snackbar toast from the interceptor.
 *
 * Default false so a request that no one catches still triggers the
 * fallback toast. Only requests that are guaranteed to be caught and
 * rendered inline should opt out.
 *
 * Usage:
 *   this.http.post(url, body, silentErrorContext())
 *
 * Or, when combining with anonymous requests / other contexts, merge:
 *   this.http.post(url, body, { context: silentErrorContext().context })
 */
export const SUPPRESS_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

/** Shorthand: an HttpContext with SUPPRESS_ERROR_TOAST already set. */
export function silentErrorContext(): { context: HttpContext } {
  return { context: new HttpContext().set(SUPPRESS_ERROR_TOAST, true) };
}
